import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const navCategories = categories.slice(0, 6);

export default function Navbar() {
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-foreground-50 text-lg"></i>
            </div>
            <span className="font-heading text-lg font-bold text-foreground-50 hidden sm:block">
              91影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              关于我们
            </Link>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-300 hover:text-foreground-100 transition-colors"
              onClick={() => {
                const mobileMenu = document.getElementById('mobile-menu');
                if (mobileMenu) {
                  mobileMenu.classList.toggle('hidden');
                }
              }}
            >
              <i className="ri-menu-line text-lg"></i>
            </button>
          </div>
        </div>

        <div id="mobile-menu" className="hidden md:hidden pb-4 border-t border-background-200/40 mt-2 pt-3">
          <div className="flex flex-wrap gap-2">
            {navCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100 bg-background-100/50'
                }`}
                onClick={() => {
                  const mobileMenu = document.getElementById('mobile-menu');
                  if (mobileMenu) mobileMenu.classList.add('hidden');
                }}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}